function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormItem from "./FormItem";
import { getDataType } from '@/utils';
export default {
  name: "TableForm",
  components: {
    FormItem: FormItem
  },
  emits: ['search', 'reset'],
  props: {
    columns: {
      type: Number,
      default: 4
    },
    formData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    immediate: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showMore: false,
      queryParams: {}
    };
  },
  computed: {
    compStyle: function compStyle() {
      return {
        '--col': this.columns
      };
    },
    singleRowColumns: function singleRowColumns() {
      return Math.min(this.columns - 1, this.formData.length);
    },
    showMoreBtn: function showMoreBtn() {
      var isSingleRow = this.formData.length <= this.singleRowColumns;
      return !isSingleRow;
    }
  },
  watch: {
    formData: {
      handler: function handler() {
        this.setParams();
      },
      immediate: true,
      deep: true
    },
    queryParams: {
      handler: function handler() {
        this.setFormDataValue();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    if (this.immediate) {
      this.search();
    }
  },
  methods: {
    emptyValue: function emptyValue(value) {
      return value === '' || value === void 0 || value === null;
    },
    setParams: function setParams() {
      var _this = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'init';
      var list = this.formData;
      list.forEach(function (item) {
        if (item.type === 'user-select-input') {
          if (type === 'init') {
            item.defaultValue = {
              searchType: 'all',
              content: ''
            };
          }
        }
        var val = item.defaultValue;
        if (type === 'init' && item.value) {
          val = item.value;
        }
        // 如果初始化过属性，且值为一个json对象，为了页面渲染相应，循环赋值其中的值，而不是赋值整个对象
        if (typeof _this.queryParams[item.prop] !== 'undefined') {
          if (getDataType(val) === 'object') {
            for (var k in val) {
              _this.$set(_this.queryParams[item.prop], k, val[k]);
            }
            return;
          }
        }
        _this.$set(_this.queryParams, item.prop, val);
      });
    },
    resetParams: function resetParams() {
      this.setParams('reset');
    },
    setFormDataValue: function setFormDataValue() {
      var _this2 = this;
      var list = this.formData;
      list.forEach(function (item) {
        item.value = _this2.queryParams[item.prop];
      });
    },
    search: function search() {
      this.handleSearch();
    },
    reset: function reset() {
      var _this3 = this;
      this.resetParams();
      this.$nextTick(function () {
        _this3.handleSearch('reset');
      });
    },
    handleSearch: function handleSearch() {
      var _this4 = this;
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'search';
      var params = _objectSpread({}, this.queryParams);
      var list = this.formData;
      list.forEach(function (item) {
        if (['dateRange', 'datetimeRange'].includes(item.type)) {
          params[item.options.startKey] = params[item.prop] && params[item.prop][0] || '';
          params[item.options.endKey] = params[item.prop] && params[item.prop][1] || '';
          delete params[item.prop];
        } else if (getDataType(item.value) === 'object') {
          for (var k in item.value) {
            params[k] = item.value[k];
          }
          delete params[item.prop];
        }
      });
      Object.keys(params).forEach(function (key) {
        if (_this4.emptyValue(params[key])) {
          delete params[key];
        }
      });
      this.$emit(event, params);
    }
  }
};